import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { getForms } from 'actions/templates';
import Card, { CardFooter, CardsContainer, CardTitle } from 'components/Presentation/Cards/Card';
import SectionTitle from 'components/Presentation/SectionTitle';
import Moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
var AllForms = /*#__PURE__*/function (_Component) {
  function AllForms() {
    var _this;
    _classCallCheck(this, AllForms);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AllForms, [].concat(args));
    _defineProperty(_this, "componentDidMount", function () {
      _this.props.getForms();
    });
    return _this;
  }
  _inherits(AllForms, _Component);
  return _createClass(AllForms, [{
    key: "render",
    value: function render() {
      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "section"
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement("span", null, translate('All forms'))), this.props.forms != null ? /*#__PURE__*/React.createElement(CardsContainer, null, this.props.forms.map(function (form) {
        var instance = form.formInstances[0];
        return /*#__PURE__*/React.createElement(Card, {
          type: "group",
          key: form.id,
          id: form.id,
          target: "/form/".concat(form.id)
        }, instance.status == 'SUBMITTED' ? /*#__PURE__*/React.createElement("div", {
          className: "card-meta"
        }, translate('Submitted'), " ", Moment(instance.edited).format('D MMM - kk:mm')) : null, /*#__PURE__*/React.createElement(CardTitle, null, form.title), /*#__PURE__*/React.createElement(CardFooter, null));
      })) : null));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    forms: state.Templates.forms,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  getForms: getForms
})(AllForms);